<cc-form-container [isLoading]="isLoading$ | async">
  <ng-container form-buttons>
    <cc-delete-action-button
      (onClick)="delete(formGroup.controls.id.value)"
      [disabled]="isLoading$ | async"
      tooltip="common.DELETE"
      [icon]="faTimes"
      displayText="common.DELETE"
    >
    </cc-delete-action-button>
    <cc-save-action-button (onClick)="submit()" class="button-align">
    </cc-save-action-button>
  </ng-container>

  <form
    [formGroup]="formGroup"
    form-content
    [patchFormGroupValues]="value$ | async"
  >
    <div formContainerCol>
      <div formContainerFormRow>
        <mat-form-field class="w-full">
          <mat-label>{{
            'norm-cubic-meter.fields.YEAR' | transloco
          }}</mat-label>
          <input formControlName="year" matInput type="number" />
        </mat-form-field>
      </div>
      <div formContainerFormRow>
        <mat-form-field class="w-full">
          <mat-label>{{
            'norm-cubic-meter.fields.FACTOR' | transloco
          }}</mat-label>
          <input type="number" formControlName="factor" matInput />
        </mat-form-field>
      </div>
    </div>
  </form>
</cc-form-container>
